import { notification } from '@pu/mpp-ui/notifications';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { SLICE_NAMESPACE } from '../shortcuts.constants';
import { IShortcutsState } from '../shortcuts.types';
import { fetchShortcuts } from './fetchShortcuts';

export const deleteShortcut = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/deleteShortcut`,
  async (id: number, { dispatch }) => {
    try {
      await apiService.shortcuts.deleteShortcut(id);

      notification.success('Shortcut eliminado correctamente.');

      await dispatch(fetchShortcuts());
    } catch (error) {
      const errorMessage = handleErrorMessage(error, 'Ocurrió un error al actualizar el shortcut.');

      showNotificationError(errorMessage);
      throw error;
    }
  },
);

export const deleteShortcutReducer: TSliceExtraReducer<IShortcutsState> = builder =>
  builder
    .addCase(deleteShortcut.pending, state => {
      state.deleteConfirmation.isLoading = true;
      state.deleteConfirmation.isSuccess = false;
      state.deleteConfirmation.error = null;
    })
    .addCase(deleteShortcut.rejected, state => {
      state.deleteConfirmation.isLoading = false;
      state.deleteConfirmation.isSuccess = false;
    })
    .addCase(deleteShortcut.fulfilled, state => {
      state.deleteConfirmation.isLoading = false;
      state.deleteConfirmation.isSuccess = true;
      state.deleteConfirmation.error = null;
    });
